import React, {useRef, useState} from 'react';
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import CellCenter from "../../../components/cell-center";
import {useNavigate} from "react-router-dom";
import StatusCellRenderer from "./status-cell-renderer";
import moduleCellRenderer from "./module-cell-renderer";
import useFetchData from "../hooks/use-fetch-data";
import general from "../../../utils/general";

const LastAttendances = ({project, setIsLoading}) => {
    const {attendances} = useFetchData(project);
    const navigate = useNavigate();
    const gridRef = useRef();

    const onCellClicked = (cell) => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            navigate(`/software-attendances/form/${cell.data.id}`)
        }, 100);
    }

    const [columnDefs] = useState([
        {field: "id", headerName: "ID", width: 70, cellRenderer: CellCenter},
        {field: "dt_initial", headerName: "Abertura", width: 150,
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        {field: "status", headerName: "Status", width: 140, cellRenderer: StatusCellRenderer},
        {field: "requester", headerName: "Solicitante", flex: 1, minWidth: 250},
        {field: "problem", headerName: "Descrição", flex: 2, minWidth: 250},
        {field: "module_name", headerName: "Módulo", width: 250, cellRenderer: moduleCellRenderer}
    ]);

    return (
        <Card title={"Atendimentos"} wrapperClass={"mt-4"}>
            <div className={"ag-theme-quartz grid"}>
                <AgGridReact
                    ref={gridRef}
                    rowHeight={32}
                    rowData={attendances ?? []}
                    columnDefs={columnDefs}
                    animateRows={false}
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    domLayout='autoHeight'
                    onCellClicked={onCellClicked}
                    gridOptions={{localeText: LocalizationAgGrid}}
                />
            </div>
        </Card>
    );
};

export default LastAttendances;